module.exports = __webpack_public_path__ + "img/treasure-of-the-templars.3fe59125.jpg";